import { createContext } from 'react';

const PassportContext = createContext();

export default PassportContext;